import FraudIncidentManagementService from "../../../services/FraudIncidentManagementService";
import commonFunc from "../../../common.func";

const actions = {
    async GET_CASES(context, { filters, stateKey }) {
        context.commit("changeIncidentLoading", { isLoading: true, stateKey: stateKey });
        context.commit("clearData", stateKey);
        try {
            const selectedEntityId = context.rootState.commonStates.selectedEntity;
            if (selectedEntityId && filters != null) {
                const incidentState = context.state[stateKey]
                const payload = {
                    ExecutionDTO: filters,
                    PaginationRequest: {
                        currentPage: incidentState.tableOptions.page,
                        itemsPerPage: incidentState.tableOptions.itemsPerPage,
                        isDesc: incidentState.tableOptions.sortDesc.length ? incidentState.tableOptions.sortDesc[0] : false,
                        orderColumn: incidentState.tableOptions.sortBy.length ? incidentState.tableOptions.sortBy[0] : null,
                        serviceEntityId: selectedEntityId // TODO ATI: kullanılacak mı?
                    }
                };
                const { data } = await FraudIncidentManagementService.execute(payload);
                context.commit("updateIncidents", { result: data.result, stateKey: stateKey });
            }
        } catch (error) {
            console.log(error);
        }
        context.commit("changeIncidentLoading", { isLoading: false, stateKey: stateKey });
    },
    async CALL_INCIDENT_REST_SERVICE(context, { obj, stateKey }) {
        context.commit("changeIncidentLoading", { value: true, stateKey: stateKey });
        try {
            const { data } = await FraudIncidentManagementService.callRestService(obj);
            if (data.result && data.statusCode == 200) {
                context.commit("changeServiceResponseLoading", { value: true, stateKey: stateKey });
                context.commit("changeServiceResponseMessage", { value: commonFunc.localize("serviceCalledSuccesfully"), stateKey: stateKey });
            } else if(data.statusCode == 617){
                context.commit("changeServiceResponseLoading", { value: false, stateKey: stateKey });
                context.commit("changeServiceResponseMessage", { value: data?.message, stateKey: stateKey });
            } 
            else {
                context.commit("changeServiceResponseLoading", { value: false, stateKey: stateKey });
                context.commit("changeServiceResponseMessage", { value: data?.errorListMessage, stateKey: stateKey });
            }
        } catch (error) {
            context.commit("changeServiceResponseLoading", { value: false, stateKey: stateKey });
            context.commit("changeServiceResponseMessage", { value: commonFunc.localize("errorOccuredWhileCallingService"), stateKey: stateKey });
        }
        context.commit("changeIncidentLoading", { value: false, stateKey: stateKey });
    }
}

export default actions;